import { Component, Input, OnChanges, ViewEncapsulation } from '@angular/core';
import {
  Maybe,
  TixCompanyAddress,
  TixPhoneNumber,
  TixVenue,
  TixVenueAddress
} from '@tix/data-access';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { PortalVenueInfo } from '@tix/event-buyer/services';
function firstOrNull<T>(array: Array<T> = []): T | null {
  return array[0] ?? null;
}

@Component({
  selector: 'tix-venue-info',
  templateUrl: './venue-info.component.html',
  styleUrls: ['./venue-info.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TixVenueInfoComponent implements OnChanges {
  safeURL!: any;
  id: any;
  youtubeRegex =
    /^.*(?:(?:youtu\.be\/|v\/|vi\/|u\/\w\/|embed\/|shorts\/)|(?:(?:watch)?\?v(?:i)?=|\&v(?:i)?=))([^#\&\?]*).*/;
  @Input() venueDetail: Maybe<TixVenue | PortalVenueInfo>;
  @Input() venueId: string;

  constructor(private _sanitizer: DomSanitizer) {}

  ngOnChanges() {
    this.id = !this.venueVideo
      ? this.companyVideo?.match(this.youtubeRegex)
      : this.venueVideo?.match(this.youtubeRegex);
    if (this.id) {
      this.safeURL = this._sanitizer.bypassSecurityTrustResourceUrl(
        'https://www.youtube.com/embed/' + this.id[1]
      );
    }
  }

  get phoneNumbers(): TixPhoneNumber[] {
    if (
      this.venueDetail?.phoneNumbers.length &&
      this.venueDetail?.phoneNumbers?.[0].phoneNumber?.sameAsCompany
    ) {
      return (
        this.venueDetail?.company?.phoneNumbers?.map(
          p => p.phoneNumber as TixPhoneNumber
        ) || []
      );
    }
    return (
      this.venueDetail?.phoneNumbers?.map(
        p => p.phoneNumber as TixPhoneNumber
      ) || []
    );
  }

  get venueAddress(): Maybe<TixVenueAddress> {
    return firstOrNull(this.venueDetail?.addresses) as TixVenueAddress;
  }
  get warningsLength(): number {
    return this.venueDetail?.company?.warnings?.length ?? 0;
  }
  get companyAddress(): Maybe<TixCompanyAddress> {
    return firstOrNull(
      this.venueDetail?.company?.addresses
    ) as TixCompanyAddress;
  }

  get venueMedias(): string | undefined {
    if (
      this.venueDetail?.mediaFiles === null ||
      !this.venueDetail?.mediaFiles?.length
    ) {
      return '';
    }
    return this.venueDetail?.mediaFiles[0]?.mediaFile?.location;
  }

  get venueVideo(): string | undefined {
    if (
      this.venueDetail?.mediaFiles === null ||
      !this.venueDetail?.mediaFiles?.length
    ) {
      return '';
    }
    return this.venueDetail?.mediaFiles[1]?.mediaFile?.location;
  }

  get companyVideo(): string | undefined {
    if (
      this.venueDetail?.company?.mediaFiles === null ||
      !this.venueDetail?.company?.mediaFiles?.length
    ) {
      return '';
    }
    return this.venueDetail?.company?.mediaFiles[1]?.mediaFile?.location;
  }

  get companyMedias(): string | undefined {
    if (
      this.venueDetail?.company?.mediaFiles === null ||
      !this.venueDetail?.company?.mediaFiles?.length
    ) {
      return '';
    }
    return this.venueDetail?.company?.mediaFiles[0]?.mediaFile?.location;
  }

  formatPhoneNumber(phoneNumber: Maybe<string>) {
    if (!phoneNumber) return '';

    return '1.' + phoneNumber.split('-').join('.');
  }

  getPhoneNumberHref(phoneNumber: Maybe<string>) {
    if (!phoneNumber) return '';

    return 'tel:' + phoneNumber.split('-').join('');
  }

  formattedVenueAddress(): string {
    if (this.venueAddress?.address) {
      return [
        this.venueAddress?.address?.sameAsCompany
          ? `${this.companyAddress?.address?.streetAddress ?? ''},
         ${this.companyAddress?.address?.city ?? ''},
           ${this.companyAddress?.address?.stateProvince ?? ''} ${
              this.companyAddress?.address?.postalCode ?? ''
            }`.trim()
          : `${this.venueAddress?.address?.streetAddress ?? ''} ,
           ${this.venueAddress?.address?.city ?? ''},
           ${this.venueAddress?.address?.stateProvince ?? ''} ${
              this.venueAddress?.address?.postalCode ?? ''
            }`.trim()
      ]
        .filter(v => !!v)
        .join(', ');
    } else {
      return '';
    }
  }
}
